export const LogoMark = ({ size = 32, animated = false }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <rect x="7" y="7" width="18" height="18" rx="4" transform="rotate(45 16 16)" stroke="#00F0FF" strokeWidth="2" />
    <path
      d="M4 16.5h7l2-4.5 3.5 8 2.5-6 1.5 2.5H28"
      stroke="#F8FAFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      className={animated ? "pulse-draw" : ""}
    />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark animated />
    <span className="font-display text-xl font-bold tracking-tight text-white">
      swayam<span className="text-[#00F0FF]">scale</span>
    </span>
  </span>
);
